import { BREADCRUMBLIST_ACTION } from "hooks/actions/etcAction";
import { MENU_ACTION } from "hooks/actions/etcAction";
import { REFRESH_MENU_ACTION } from "hooks/actions/etcAction";
import { REFRESH_MENU_GROUP_ACTION } from "hooks/actions/etcAction";
import { ASSIGNED_MENU_ACTION } from "hooks/actions/etcAction";
import { OPENKEYS_ACTION } from "hooks/actions/etcAction";
import { SELECTKEYS_ACTION } from "hooks/actions/etcAction";
import etcState from "./etcState";

const etcReducer = (state = etcState, action) => {
  switch (action.type) {
    case BREADCRUMBLIST_ACTION:
      return Object.assign({}, state, {
        breadCrumbList: action.payload
      });
    
    case MENU_ACTION:
      return Object.assign({}, state, {
        menuGroupList:action.payload.menuGroupList,
        menuList: action.payload.menuList
      });

    case REFRESH_MENU_GROUP_ACTION:
      return Object.assign({}, state, {
        allMenuGroup:action.payload.allMenuGroup,
      });

    case REFRESH_MENU_ACTION:
      return Object.assign({}, state, {
        allMenu: action.payload.allMenu
      });

    case ASSIGNED_MENU_ACTION:
      return Object.assign({}, state, {
        assignedMenu: action.payload.assignedMenu
      });

    case OPENKEYS_ACTION:
      return Object.assign({}, state, {
        openKeys: action.payload.openKeys,
      });

    case SELECTKEYS_ACTION:
      return Object.assign({}, state, {
        selectKeys: action.payload.selectKeys
      });

    default:
      return state;
  }
};

export default etcReducer;
